"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Section = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var section_header_1 = require("./header/section-header");
var section_style_1 = require("./section-style");
function Section(props) {
    var children = props.children, headerProps = props.headerProps;
    return ((0, jsx_runtime_1.jsxs)(section_style_1.StyledSection, { children: [(0, jsx_runtime_1.jsx)(section_header_1.SectionHeader, __assign({}, headerProps)), (0, jsx_runtime_1.jsx)(section_style_1.StyledSectionSeparator, {}), (0, jsx_runtime_1.jsx)(section_style_1.StyledSectionBody, { children: children })] }));
}
exports.Section = Section;
